import { render, staticRenderFns } from "./AxSpinner.vue?vue&type=template&id=daeee2b4&"
import script from "./AxSpinner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AxSpinner.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daeee2b4')) {
      api.createRecord('daeee2b4', component.options)
    } else {
      api.reload('daeee2b4', component.options)
    }
    module.hot.accept("./AxSpinner.vue?vue&type=template&id=daeee2b4&", function () {
      api.rerender('daeee2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/AxSpinner/AxSpinner.vue"
export default component.exports